import { useCallback } from 'react';
import { useAppDispatch, useAppSelector , useModal } from '@store/hooks';

import { MODAL_TYPES } from '../../../components/modals/constants';
import { selectShouldShowCSAT } from '../store/selectors';
import { setLastCSATShownTimestamp } from '../store/slice';
import type { CSATConfig } from '../types';

/**
 * Hook for triggering CSAT modal with timing logic
 * Only shows if it's the first time or >14 days since last shown
 */
export function useCSATTrigger() {
  const shouldShow = useAppSelector(selectShouldShowCSAT);
  const dispatch = useAppDispatch();
  const { open } = useModal();

  const triggerCSAT = useCallback(
    (config: CSATConfig) => {
      if (!shouldShow) return;

      open(MODAL_TYPES.CSAT, config);
      dispatch(setLastCSATShownTimestamp(Date.now()));
    },
    [shouldShow, open, dispatch],
  );

  return { triggerCSAT, shouldShow };
}
